export const selectStringFilter = (inputValue, option) => option.children?.toUpperCase().includes(inputValue.toUpperCase());
